import { selectPlatformNotices } from 'client/store/systemMessageSlice/systemMessageSlice';
import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

export const usePlatformNotices = (date = Date.now()) => {
    const platformNotices = useSelector(selectPlatformNotices, shallowEqual);

    // get messages without exceeding 180 days into future
    const now = new Date(date).getTime();
    const maxDate = new Date(now);
    maxDate.setDate(maxDate.getDate() + 180);

    return useMemo(() => platformNotices.filter(notice => {
        const startDate = new Date(notice.start).getTime();
        return startDate >= now && startDate <= maxDate.getTime();
    }), [platformNotices, now, maxDate]);
};
